import { form, errors, imageLoadError } from '../state'

/**
 * Düzenleme için öneri verilerini form durumuna yükler
 * @param {Object} suggestion - Yüklenecek öneri verisi
 */
export const loadSuggestionData = (suggestion) => {
  if (!suggestion) return

  // Form verilerini güncelle
  form.suggestion = suggestion.suggestion || ''
  form.currentImageUrl = suggestion.currentImageUrl || ''
  form.currentVideoUrl = suggestion.currentVideoUrl || ''
  form.currentText = suggestion.currentText || ''
  form.priority = suggestion.priority || 3

  // Hata durumlarını temizle
  imageLoadError.value = false
  Object.keys(errors).forEach(key => errors[key] = '')
}
